import styled, { createGlobalStyle } from "styled-components";

const colors = {
  primary: "#0052CC",
  border: "#DFE1E6",
  success: "#28a745",
  danger: "#dc3545",
};

export const GlobalPopupStyles = createGlobalStyle`
  .custom-form-popup .dx-popup-title .dx-toolbar-label {
    white-space: normal !important;
    line-height: 1.4 !important;
    height: auto !important;
  }
`;

const BaseButton = styled.button`
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  &:focus {
    outline: none;
  }
`;

export const SaveButton = styled(BaseButton)`
  border: 2px solid ${colors.success};
  color: ${colors.success};
  &:hover {
    background-color: ${colors.success};
    color: #fff;
  }
`;

export const CancelButton = styled(BaseButton)`
  border: 2px solid ${colors.danger};
  color: ${colors.danger};
  margin-right: 12px;
  &:hover {
    background-color: ${colors.danger};
    color: #fff;
  }
`;

export const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #ddd;
  margin-top: 1rem;
`;

export const PageWrapper = styled.div`
  padding: 1.5rem;
  background-color: #f8fafc;
`;

export const Header = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: black;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const FormContainer = styled.div`
  padding: 1rem;
`;

export const SectionToolbar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;
